import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import { ConfigService } from '../../../../../core';
import { ConfigCliente } from '../../../../configuracoes/app/cliente';
import { ConfigEmpresa } from '../../../../configuracoes/app/empresa';

interface Config {
    showCard: boolean;
}

@Component({
    selector: 'sgt-card-message-carta-isencao-ipi-vencida',
    templateUrl: './card-message-carta-isencao-ipi-vencida.component.html',
    styleUrls: ['./card-message-carta-isencao-ipi-vencida.component.less']
})
export class CardMessageCartaIsencaoIpiVencidaComponent implements OnInit, OnChanges {
    config: Config;
    configEmpresa: ConfigEmpresa;
    configCliente: ConfigCliente;

    @Input() cartaIsencaoIpiVencida: boolean;

    constructor(private configService: ConfigService) { }


    ngOnInit(): void {
        this.configEmpresa = this.configService.getEmpresa();
        this.configCliente = this.configService.getCliente();
        this.setConfig();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'cartaIsencaoIpiVencida') {
                this.setConfig();
            }
        }
    }

    private setConfig() {
        this.config = {
            showCard: this.isShowCard(),
        }
    }

    /** Verifica se deve exibir o card com a mensagem de carta de isenção de IPI vencida */
    private isShowCard(): boolean {
        // Se estiver configurado para não exibir a Isenção de IPI do cliente
        if (!this.configEmpresa?.aplicaIpi) {
            return false;
        }
        // Sem mensagem configurada
        if (!this.configCliente?.mensagemCartaIsencaoIpiVencida) {
            return false;
        }

        return this.cartaIsencaoIpiVencida;
    }
}
